import React, { useEffect, useMemo, useState } from "react";
import styles from "./style.module.scss";
import { ScreenId } from "utils";
import { post } from "utils/ApiUtil";
import { IFiles } from "data/common";
import useNav from "hooks/useNav";
import { FileUploadButton } from "components";
import { Svgs } from "assets";
import useUser from "hooks/useUser";

interface IInputData {
  files?: IFiles[];
}

export default function Page() {
  const { navigate } = useNav();
  const { user } = useUser();
  const [step, setStep] = useState(0);
  const [inputData, setInputData] = useState<IInputData>({});

  const isNext: boolean = useMemo(() => {
    if ((inputData.files || []).length !== 1) {
      return false;
    }
    return true;
  }, [inputData]);

  const viewList = [
    <ViewPage1
      key={1}
      data={inputData}
      setData={setInputData}
      isNext={isNext}
      next={next}
    />,
  ];

  function next() {
    if (step + 1 === viewList.length) {
      submit();
      return;
    }
    setStep((prev) => prev + 1);
  }

  async function submit() {
    try {
      if ((inputData.files || []).length === 0) {
        return alert("캡쳐한 공지이미지를 등록해주세요.");
      }

      const params = {
        files: [
          ...(inputData.files || []).map((item) => ({
            ...item,
            title: "인증서류",
          })),
        ],
      };
      const { success, message } = await post(
        "/api/user/createPromotionKakao",
        params,
        undefined,
        false,
      );
      if (success) {
        alert(
          "오픈카톡방 인증이 정상적으로 완료 되었습니다. 관리자 확인 후 승인처리 진행됩니다.",
        );
        navigate({ url: ScreenId.HOME });
      } else {
        alert(message);
      }
    } catch (error) {
      console.warn("submit error", error);
    }
  }

  useEffect(() => {
    // 기 신청자 막기
    if (!!user?.auth_type) {
      alert(`이미 ${user?.auth_type} 인증 완료되었습니다.`);
      return navigate({ url: ScreenId.SIGN_IN });
    }
    if (!!user?.wait_auth_type) {
      alert(`${user?.wait_auth_type} 인증 승인 대기중입니다.`);
      return navigate({ url: ScreenId.SIGN_IN });
    }
  }, []);

  return (
    <div className={styles.container}>
      <div
        className={styles.slideContainer}
        style={{
          width: `${viewList.length * 100}%`,
          left: `-${step * 100}%`,
        }}
      >
        {viewList}
      </div>
    </div>
  );
}

function ViewPage1({
  data,
  setData,
  isNext,
  next,
}: {
  data: IInputData;
  setData: (data: IInputData) => void;
  isNext: boolean;
  next: () => void;
}) {
  return (
    <div className={styles.page}>
      <div className={styles.fileUploadTitle}>
        오픈 카톡방에서 캡쳐한 공지 이미지를 등록해주세요.
      </div>
      <div className={styles.uploadContainer}>
        <FileUploadButton
          containerClassname={styles.uploadBtn}
          disabled={(data.files || []).length >= 1}
          children={
            <div className={styles.uploadBtnContent}>
              <Svgs.SvgPlus />
              <span>파일첨부</span>
            </div>
          }
          type="all"
          accept="image/*,.pdf"
          uploadUrl={"/api/utils/promotionUploadImage"}
          uploadFileUrl={"api/utils/b2bUploadFile"}
          fileUpload={(_files) => {
            const newFiles: IFiles[] = [
              ...(_files.files || []).map((item, index) => {
                const imgUrl = item;
                const fileName = _files.fileData[index].name;
                return {
                  url: imgUrl,
                  thumb_img_url: imgUrl,
                  origin_file_name: fileName,
                };
              }),
            ];
            setData({ ...data, files: [...(data.files || []), ...newFiles] });
          }}
        />
        {(data.files || []).map((item, index) => (
          <div className={styles.fileItem} key={index}>
            <div>
              <Svgs.SvgDocument />
            </div>
            <div>{item.origin_file_name}</div>
            <div
              onClick={() =>
                setData({
                  ...data,
                  files: (data.files || []).filter(
                    (values, _index) => index !== _index,
                  ),
                })
              }
            >
              <Svgs.SvgClose />
            </div>
          </div>
        ))}

        <div className={styles.fileDesc}>
          <div>*</div>
          <div>
            jpg, png, pdf 파일만 첨부 가능하며, 최대 10MB 까지 첨부가능합니다.
          </div>
        </div>
      </div>
      <div style={{ marginTop: 34 }}>
        <button
          className={[styles.confirmBtn, isNext && styles.active].join(" ")}
          onClick={next}
        >
          등록할게요
        </button>
      </div>
      <div className={styles.bottomInfo}>
        <div className={[styles.row, styles.title].join(" ")}>
          <Svgs.SvgAlert />
          오픈카톡방 인증 안내
        </div>
        <div className={styles.row}>
          <ul>
            <li>
              첨부해주신 인증 화면을 확인하여 관리자 승인 후 혜택을 드립니다.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
